import { Link } from "react-router-dom";

export default function Footer() {
  const quickLinks = [
    { label: "首页", to: "/" },
    { label: "影视剧", to: "/category/drama" },
    { label: "综艺", to: "/category/variety" },
    { label: "原创", to: "/category/original" },
  ];
  const catLinks = [
    { label: "动漫", to: "/category/anime" },
    { label: "纪录片", to: "/category/documentary" },
    { label: "精选专题", to: "/topic/featured-drama" },
    { label: "关于我们", to: "/about" },
  ];

  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="text-2xl font-black">
                <span className="text-background-50">精品</span>
                <span className="text-secondary-400">视频</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-md">
              精品视频是聚焦高清视频资源的聚合平台，汇聚影视剧、娱乐综艺与原创内容，为喜爱免费视频的你提供便捷、舒适、多样化的在线观看体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map((ic) => (
                <span
                  key={ic}
                  className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-900 text-background-200 hover:bg-primary-800 cursor-pointer transition-colors"
                >
                  <i className={ic} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-background-300 hover:text-secondary-300 cursor-pointer transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {catLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-background-300 hover:text-secondary-300 cursor-pointer transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 精品视频 · 本平台内容仅供学习交流与演示，不提供下载、付费与注册服务。</p>
          <p>高清免费视频资源聚合平台</p>
        </div>
      </div>
    </footer>
  );
}